<template>
    <fullscreen-drawer
        v-if="featureFlags['live-site-responsive-design']"
        :visible="visible"
        height="auto"
        title="Export"
        @close="handleClose"
    >
        <g-loader v-if="isLoading" />
        <div v-else>
            <g-typography tag="h3" class="g-mb-3">{{ totalSelected }} total selections</g-typography>

            <g-typography
                tag="p"
                color="grey-6"
                class="g-mb-6"
                value="Use the filter to narrow down your selections."
            />

            <g-button shape="round" theme="live" type="primary" block size="large" @click="handleExport">
                Send Export by Email
            </g-button>
        </div>
    </fullscreen-drawer>

    <g-drawer v-else :visible="visible" height="auto" get-container="#app" placement="bottom" @close="handleClose">
        <g-loader v-if="isLoading" />
        <div v-else>
            <g-typography tag="h2" font-weight="semibold" class="g-mb-6" value="Export" />

            <g-typography tag="h3" class="g-mb-3">{{ totalSelected }} total selections</g-typography>

            <g-typography
                tag="p"
                color="grey-6"
                class="g-mb-6"
                value="Use the filter to narrow down your selections."
            />

            <g-button shape="round" theme="live" type="primary" block size="large" @click="handleExport">
                Send Export by Email
            </g-button>
        </div>
    </g-drawer>
</template>

<script>
    import { ref, computed } from 'vue-demi';
    import { commas } from '../../../../helpers';
    import {
        PAYMENTS_TAB,
        CONVERSIONS_TAB,
        PAYOUT_TYPE_PAYOUT,
        PAYOUT_TYPE_CONVERSION
    } from '../../../../../app-v2/constants/payouts';
    import usePayments from '../../../../composables/use-payments';
    import {useContactStore, useFeatureFlagsStore} from '../../../../../stores';
    import { message } from '@grininc/grin-ui';
    import useEventTracking from '../../../../composables/use-event-tracking';
    import {
        EVENT_NAME_PAYOUT_DETAILS_EXPORTED,
    } from '../../../../../app-v2/constants/analytics-events';
    import FullscreenDrawer from "../../../../../app-v2/components/library/FullscreenDrawer";

    export default {
        name: 'PaymentsAndConversionsExportDrawer',
        components: {FullscreenDrawer},
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            total: {
                type: Number,
                default: 0
            },
            filterStartDate: {
                type: String,
                default: ''
            },
            filterEndDate: {
                type: String,
                default: ''
            },
            tab: {
                type: String,
                default: ''
            }
        },

        setup(props, context) {
            const contact = useContactStore().data;
            const featureFlags = useFeatureFlagsStore().data;

            const isLoading = ref(false);

            const isPayout = computed(() => {
                return props.tab === PAYMENTS_TAB;
            });

            const totalSelected = computed(() => {
                return props.total ? commas(props.total) : '';
            });

            const handleClose = () => {
                context.emit('close');
            };

            const getType = () => {
                return isPayout.value ? PAYOUT_TYPE_PAYOUT : PAYOUT_TYPE_CONVERSION;
            };

            //track events
            const events = useEventTracking();

            const handleExport = async () => {
                isLoading.value = true;

                try {
                    await usePayments().exportPayments(
                        contact.id,
                        getType(),
                        props.filterStartDate,
                        props.filterEndDate
                    );

                    message.success('Your report has been emailed.');
                } catch (e) {
                    message.error('There was an error while trying to export your payouts, please try again later.');
                }


                const getPaymentExportEventPayload = () => {
                    return {
                        dl_contact_id: contact.id,
                        export_size: props.total
                    };
                };

                events.trackEvent(EVENT_NAME_PAYOUT_DETAILS_EXPORTED, getPaymentExportEventPayload());

                handleClose();
                isLoading.value = false;
            };

            return {
                totalSelected,
                isLoading,
                featureFlags,
                handleExport,
                handleClose
            };
        }
    };
</script>
